const TOAST_MESSAGE = {
  REGISTER: '登録に成功しました。',
  UPDATE: '更新に成功しました。',
  DELETE: '削除しました。',
  SAVE_DRAFT: '下書きを保存しました。',
  SEND: '送信しました。',
  RESEND: '送信しました。60秒後に再送信できます',
  LOAD_FAILED: 'データの取得に失敗しました。',
} as const;

export default TOAST_MESSAGE;
